module.exports = __webpack_public_path__ + "static/media/4en.6a0c04ed.jpg";